exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_cover_2vkPVzj_y-hasegA3WQrgR {\n  width: 620px;\n  height: 338px;\n  position: relative;\n  float: left;\n  cursor: pointer;\n}\n", ""]);

// Exports
exports.locals = {
	"IA_cover": "IA_cover_2vkPVzj_y-hasegA3WQrgR"
};